import gql from 'graphql-tag';

export const StartTrialMutation = gql`
  mutation startTrial($account: ID!) {
    startTrial(account: $account)
  }
`;